import { TransactionPurpose } from "@prisma/client";
import {
  ShoppingCart,
  DollarSign,
  Landmark,
  RotateCw,
  CreditCard,
  FileText,
  Percent,
  Repeat,
  Send,
  ArrowDownCircle,
  Calendar,
  Briefcase,
  UserCheck,
  PieChart,
  Shield,
  Home,
  Zap,
  Heart,
  TrendingUp,
  Globe,
  Gift,
  Award,
  AlertCircle,
  Star,
  Sliders,
} from "lucide-react";

type PurposeType = "INCOMING" | "NEUTRAL" | "OUTGOING";

const PurposeIcons: Record<
  TransactionPurpose,
  { component: React.ComponentType; color: string; type: PurposeType }
> = {
  WITHDRAWAL: { component: DollarSign, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  FEE: { component: FileText, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  LOAN_REPAYMENT: { component: DollarSign, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  TAX: { component: FileText, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  RENT: { component: Home, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  PENALTY: { component: AlertCircle, color: "#FF4500", type: "OUTGOING" }, // OrangeRed (Outgoing)
  PURCHASE: { component: ShoppingCart, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  PAYMENT: { component: CreditCard, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  TRANSFER_TO_OTHER_ACCOUNT: {
    component: Send,
    color: "#FF6347",
    type: "OUTGOING",
  }, // Tomato (Outgoing)
  STANDING_ORDER: { component: Calendar, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  INSURANCE_PREMIUM: { component: Shield, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  UTILITY_BILL: { component: Zap, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  DONATION: { component: Heart, color: "#FF6347", type: "OUTGOING" }, // Tomato (Outgoing)
  DIRECT_DEBIT: {
    component: ArrowDownCircle,
    color: "#FF4500",
    type: "OUTGOING",
  }, // OrangeRed (Outgoing)
  TRANSFER_TO_OWN_ACCOUNT: {
    component: Repeat,
    color: "#FFD700",
    type: "NEUTRAL",
  }, // Gold (Neutral)
  SUBSCRIPTION: { component: Repeat, color: "#FFD700", type: "NEUTRAL" }, // Gold (Neutral)
  FOREIGN_EXCHANGE: { component: Globe, color: "#FFD700", type: "NEUTRAL" }, // Gold (Neutral)
  ADJUSTMENT: { component: Sliders, color: "#FFD700", type: "NEUTRAL" }, // Gold (Neutral)
  DEPOSIT: { component: Landmark, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  INTEREST: { component: Percent, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  SALARY: { component: Briefcase, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  DIVIDEND: { component: PieChart, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  INVESTMENT: { component: TrendingUp, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  CASHBACK: { component: Gift, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  REWARD: { component: Award, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  BONUS: { component: Star, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  COMMISSION: { component: DollarSign, color: "#32CD32", type: "INCOMING" }, // LimeGreen (Incoming)
  REFUND: { component: RotateCw, color: "#3CB371", type: "INCOMING" }, // MediumSeaGreen (Incoming)
  PENSION: { component: UserCheck, color: "#3CB371", type: "INCOMING" }, // MediumSeaGreen (Incoming)
  CHARGEBACK: { component: RotateCw, color: "#3CB371", type: "INCOMING" }, // MediumSeaGreen (Incoming)
  REVERSAL: { component: RotateCw, color: "#3CB371", type: "INCOMING" }, // MediumSeaGreen (Incoming)
  UNKNOWN: { component: AlertCircle, color: "#6f6f6f", type: "NEUTRAL" }, // DarkGray (Neutral)
};

export { PurposeIcons };
export default PurposeIcons;
